<template>
  <meta property="og:type" content="article" />
  <template v-if="shareMetaInfo && shareMetaInfo.title">
    <meta property="og:title" :content="shareMetaInfo.title" />
    <meta name="twitter:title" :content="shareMetaInfo.title" />
  </template>
  <template v-if="shareMetaInfo && shareMetaInfo.description">
    <meta property="og:description" :content="shareMetaInfo.description" />
    <meta name="twitter:description" :content="shareMetaInfo.description" />
  </template>

  <template v-if="shareMetaInfo && shareMetaInfo.imageUrl">
    <meta
      property="og:image"
      itemprop="image primaryImageOfPage"
      name="image"
      :content="shareMetaInfo.imageUrl"
    />
    <meta name="twitter:image" :content="shareMetaInfo.imageUrl" />
    <meta name="twitter:image:src" :content="shareMetaInfo.imageUrl" />
  </template>

  <!--  Twitter card data-->
  <meta name="twitter:card" content="summary" />
  <meta name="twitter:site" content="@hiknow" />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { ShareMetaInfo } from '@/interface'

export default defineComponent({
  props: {
    shareMetaInfo: {
      type: Object,
      default: () =>
        ({
          title: '',
          description: '',
          imageUrl: ''
        } as ShareMetaInfo)
    }
  }
})
</script>
